/**
 * Avatar mapping for character IDs
 * Cross-cutting fix #30: Replaced 470-line static map with a simple function.
 * All avatars follow the same pattern: /art/avatars/${charId}.png
 */

/**
 * Get the avatar URL path for a character ID
 * @param {string} charId - The character ID
 * @returns {string|null} The avatar path, or null if no charId provided
 */
export function getCharacterAvatar(charId) {
  if (!charId) return null;
  return `/art/avatars/${charId}.png`;
}

// Legacy export — returns a Proxy that generates paths on access
// so any code doing AVATAR_MAP[id] still works without changes.
export const AVATAR_MAP = new Proxy({}, {
  get(_target, prop) {
    if (typeof prop === 'string') return `/art/avatars/${prop}.png`;
    return undefined;
  },
  has() { return true; },
});
